/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

function Head({
  description,
  lang,
  meta,
  title,
  noIndex,
  generalCard,
  twitterCard
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            twitter_author
          }
        }
      }
    `
  );

  // Setup general meta description
  const metaDescription = description || site.siteMetadata.description;
  const metaTitle = title || site.siteMetadata.title;

  // Start building META
  const metaData = [{
    name: 'description',
    content: metaDescription,
  }];

  // Build general card data
  if (generalCard) {
    metaData.push(
      {
        property: 'og:title',
        content: generalCard.title.text || metaTitle,
      },
      {
        property: 'og:description',
        content: generalCard.description.text || metaDescription,
      },
      {
        property: 'og:url',
        content: generalCard.url.text,
      },
      {
        property: 'og:image',
        content: generalCard.image.url,
      },
      {
        property: 'og:type',
        content: generalCard.type.text,
      },
      {
        property: 'og:locale',
        content: generalCard.locale.text,
      }
    );
  }

  // Build twitter card data
  if (twitterCard) {
    // Check for twitter image, add to data as needed
    if (twitterCard.image && twitterCard.image.url) {
      metaData.push(
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:image',
          content: twitterCard.image.url,
        }
      );
    } else {
      metaData.push(
        {
          name: 'twitter:card',
          content: 'summary',
        }
      );
    }

    // Add general twitter data
    metaData.push(
      {
        name: 'twitter:creator',
        content: twitterCard.twitter_handle.text || site.siteMetadata.twitter_author,
      },
      {
        name: 'twitter:title',
        content: twitterCard.twitter_title.text || metaTitle,
      },
      {
        name: 'twitter:description',
        content: twitterCard.description.text || metaDescription,
      }
    );
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      titleTemplate={`${site.siteMetadata.title} | %s`}
      meta={metaData.concat(meta)}
    >
      {noIndex && (
        <meta name="robots" content="noimageindex, noindex, nofollow, nosnippet" />
      )}
      <script async defer src="//static.cdn.prismic.io/prismic.js?repo=highnoonsite&new=true" />
      {/* <script type="text/javascript" src="https://www.bugherd.com/sidebarv2.js?apikey=vdlbgnsloend5ph5dtv9lg" async="true" /> */}
    </Helmet>
  );
}

Head.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
  noIndex: false
};

export default Head;
